import _ from "lodash";
import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export function regions(state: [] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_REGIONS_SUCCESS:
            let response = _.orderBy(action.payload, ['name'], ['asc']).filter(region => {
                if (region.presets.length > 0) {
                    let activePresets = region.presets.filter(
                        preset => preset.active == true
                    );
                    if (activePresets.length > 0) {
                        region.presets = activePresets;
                        return true;
                    } else {
                        return false;
                    }
                }
            });
            return response;
        default:
            return state;
    }
}

export function regionsLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_REGIONS:
            return true;
        case ConfigurationsActionTypes.GET_REGIONS_SUCCESS:
        case ConfigurationsActionTypes.GET_REGIONS_FAIL:
            return false;
        default:
            return state;
    }
}
